// Selecciona la mejor línea de precio/stock para agregar un producto.
// Prioridad: líneas "IMP" con stock disponible (aunque sean más caras),
// y sólo si no hay ninguna, se elige la de menor precio (empatando por warehousePriority).
export function selectBestLine(selectableLines, priceKey) {
  const importedInStock = selectableLines.filter(
    line => line.line === "IMP" && parseInt(line.stock) > 0
  );
  const candidates =
    importedInStock.length > 0 ? importedInStock : selectableLines;

  return candidates.reduce((best, current) => {
    const currentPrice = parseFloat(current[priceKey]) || 0;
    const bestPrice = parseFloat(best[priceKey]) || 0;
    if (currentPrice !== bestPrice)
      return currentPrice < bestPrice ? current : best;
    const currentPriority = parseInt(current.warehousePriority) || 0;
    const bestPriority = parseInt(best.warehousePriority) || 0;
    return currentPriority > bestPriority ? current : best;
  });
}
